<div class="fx-col my-3">
  <div class="fx-center">
    <img
      src="blocks-assets/images/certified-operators.svg"
      class="s-20 mt-3"
      [alt]="labels.certifiedOperator">
  </div>
  <p class="text-grey-500 text-center text-bold body-1 mt-3">
    {{ labels.certifiedOperator }}
  </p>
  <div class="radius-4 my-6 mx-3 px-3 bg-coolgrey min-h-32 fx-align-content-center fx-center text-justify">
    <p class="text-grey-500 text-left text-400 text-justify">
      {{ labels.certificationDescription }}
    </p>
  </div>
</div>

<!-- If is mobile-->
<ng-container *ngIf="mode === 'mobile'">
  <form
    #enbCertifiedOperator="ngForm"
    (ngSubmit)="enableCertifiedOperator(enbCertifiedOperator)">
    <ion-item-group class="px-3 pb-10">
      <!-- EMAIL -->
      <ion-item
        class="radius-4 mt-6"
        lines="full"
        [class.error]="(email.dirty || email.touched) && email.errors">
        <ion-input
          #email="ngModel"
          placeholder="Email"
          name="email"
          required
          email
          [pattern]="emailPattern"
          ngModel>
        </ion-input>
        <ion-button
          fill="clear"
          slot="end"
          (click)="email.reset()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>
      <div
        *ngIf="(email.dirty || email.touched) && email.errors"
        class="text-red-500 body-3 mt-1 ml-1 pos-abs">
        <span *ngIf="email.errors?.required">
          {{ labels.emailRequired }}
        </span>
        <span *ngIf="email.errors?.email">
          {{ labels.emailInvalid }}
        </span>
      </div>

      <!-- ID-CERTIFICATION -->
      <ion-item
        class="radius-4 mt-6"
        lines="full"
        [class.error]="(idCertification.dirty || idCertification.touched) && idCertification.errors">
        <ion-input
          #idCertification="ngModel"
          name="idCertification"
          required
          [placeholder]="labels.idCertificationPlaceholder"
          [pattern]="idCertificationPattern"
          ngModel>
        </ion-input>
        <ion-button
          fill="clear"
          slot="end"
          (click)="email.reset()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-item>
      <div
        *ngIf="(idCertification.dirty || idCertification.touched) && idCertification.errors"
        class="text-red-500 body-3 mt-1 ml-1 pos-abs">
        <span *ngIf="idCertification.errors?.required">
          {{ labels.idCertificationRequired }}
        </span>
      </div>
    </ion-item-group>
    <ion-button
      class="mx-3 mb-6"
      expand="block"
      type="submit"
      [disabled]="enbCertifiedOperator.invalid || enbCertifiedOperator.pending">
      {{ labels.confirm }}
    </ion-button>
  </form>
</ng-container>

<!-- If is browser -->
<ng-container *ngIf="mode === 'browser'">
  <div class="mt-12">
    <form
      #browserCertifiedOperator="ngForm"
      class="mt-6 max-w-150 mx-auto w-full"
      (ngSubmit)="enableCertifiedOperator(browserCertifiedOperator)">
      <!-- EMAIL -->
      <div class="mt-3">
        <mat-form-field
          appearance="fill"
          class="custom-mat-form-field w-full px-3 custom-border-bottom">
          <input
            #email="ngModel"
            matInput
            name="email"
            placeholder="Email"
            required
            email
            [pattern]="emailPattern"
            ngModel>
          <mat-error
            *ngIf="(email.dirty || email.touched) && email.errors?.required"
            class="text-red-500 body-3 ml-1 pos-abs">
            {{ labels.emailRequired }}
          </mat-error>
          <mat-error
            *ngIf="(email.dirty || email.touched) && email.errors?.email"
            class="text-red-500 body-3 ml-1 pos-abs">
            {{ labels.emailInvalid }}
          </mat-error>
          <button
            mat-icon-button
            matSuffix
            (click)="email.reset()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <!-- ID-CERTIFICATION -->
      <div class="mt-3">
        <mat-form-field
          appearance="fill"
          class="mt-6 px-3 custom-mat-form-field w-full custom-border-bottom">
          <input
            matInput
            name="idCertification"
            placeholder="{{ labels.idCertificationPlaceholder }}"
            required
            [pattern]="idCertificationPattern"
            #idCertification="ngModel"
            ngModel>
          <mat-error
            *ngIf="idCertification.errors?.required"
            class="text-red-500 body-3 ml-1 pos-abs">
            {{ labels.idCertificationRequired }}
          </mat-error>
          <button
            mat-icon-button
            matSuffix
            (click)="idCertification.reset()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="mt-6 px-3 fx-r-row">
        <button
          class="custom-mat-button-primary"
          mat-button
          type="submit"
          [disabled]="browserCertifiedOperator.invalid || browserCertifiedOperator.pending">
          {{ labels.confirm }}
        </button>
      </div>
    </form>
  </div>
</ng-container>
